// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OgxM","placeholdersHeader":"styles_placeholdersHeader__27fev","editorStyle":"styles_editorStyle__3wS0_","placeholdersBox":"styles_placeholdersBox__1xUjK"};